import React from 'react';
import './LogoContainer.scss';

interface LogoContainerProps {
  src: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'header' | 'brand' | 'mobile';
  className?: string;
}

const LogoContainer: React.FC<LogoContainerProps> = ({
  src,
  alt,
  size = 'md',
  variant = 'header',
  className = ''
}) => {
  const containerClass = `logo-container logo-container--${variant} logo-container--${size} ${className}`;

  return (
    <div className={containerClass}>
      <img src={src} alt={alt} className="logo-image" />
    </div>
  );
};

export default LogoContainer;